var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllStores(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg_sidebar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_3223",
    "data-name": "Group 3223",
    transform: "translate(-752 -2276)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1882",
    "data-name": "Rectangle 1882",
    width: 24,
    height: 24,
    transform: "translate(752 2276)",
    fill: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M20.16,7.8a1,1,0,0,0-.98-.8H4.82a1,1,0,0,0-.98.8L3,12v1a1,1,0,0,0,1,1v5a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V14h4v5a1,1,0,0,0,2,0V14a1,1,0,0,0,1-1V12ZM12,18H6V14h6ZM5,6H19a1,1,0,0,0,0-2H5A1,1,0,0,0,5,6Z",
    transform: "translate(752 2276)",
    fill: "#000",
    style: {
      fill: "#000!important"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllStores);
export default __webpack_public_path__ + "static/media/all-stores.0e1d5fae1155251277dab41cc321d681.svg";
export { ForwardRef as ReactComponent };